var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 1,
    y: 1,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#E7454C",
    stroke: "#E7454C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_Pie Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3045 41.6124C25.2031 52.4428 30.6717 64.6403 41.6087 68.636C52.5458 72.6317 64.6396 67.1639 68.6358 56.3334C72.6321 45.5029 67.1635 33.3055 56.3317 29.3098C54.018 28.3634 51.4941 27.9428 48.9702 27.9428C47.9991 27.9428 46.9749 28.0489 45.973 28.2235C45.5645 28.2946 45.973 47 45.973 47L29.3045 41.6124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M48.9702 26.4428C51.7807 26.4428 54.4764 26.9303 56.8508 27.9025C68.4288 32.1734 74.3377 45.2133 70.0431 56.8527C65.7647 68.4477 52.8186 74.3284 41.094 70.0449C29.5219 65.8172 23.6109 52.9858 27.7725 41.4309L27.9017 41.0811L30.7073 42.1436C26.8875 52.2305 32.0085 63.5317 42.1234 67.2271C52.3043 70.9465 63.5258 65.8492 67.2285 55.8142C70.9526 45.7212 65.8278 34.4115 55.7637 30.6981C53.7165 29.8607 51.4054 29.4428 48.9702 29.4428C48.2702 29.4428 47.5077 29.5049 46.7118 29.6234L46.2304 29.7012L45.7156 26.7457C46.847 26.5486 47.947 26.4428 48.9702 26.4428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1811 27.6144C35.4496 24.3063 40.6741 22.5 46 22.5C46.8284 22.5 47.5 23.1716 47.5 24V47C47.5 47.9891 46.5595 48.7074 45.6053 48.4471L23.6053 42.4471C22.81 42.2302 22.3388 41.4122 22.5502 40.6153C23.9241 35.4367 26.9893 30.8389 31.1811 27.6144ZM44.5 45.035V25.555L44.1431 25.5838C40.1366 25.9457 36.2641 27.4705 33.0146 29.9889C29.8319 32.4371 27.3883 35.7925 26.0094 39.598L25.883 39.958L44.5 45.035Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.29af9c27e107b1e72053b811a16a908a.svg";
export { ForwardRef as ReactComponent };